module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_81_sharp-zelena.646663d7.png";